export const FSFMotoLightBoxActions = {
    SHOW: 'SHOW',
    HIDE: 'HIDE',
};